import React from 'react';
import ReactDOM from 'react-dom/client';

// Global CSS imports (must be loaded first)
import './styles/fonts.css';   // @font-face — before anything that renders text
import './index.css';

// RLC design tokens — generated from brand/rlc/tokens.json.
// Phase C is live: these resolve to the RLC brand values. The Phase B
// compatibility layer (rlc-tokens-legacy.css) is no longer imported; it is still
// generated so the pre-rebrand values stay available for comparison.
import './styles/tokens/rlc-tokens.css';

import './styles/typography.css';   // applies the type tokens (needs both above)
import './styles/brandColors.css';  // legacy --brand-* aliases onto RLC tokens
import './styles/layout.css';       // Main layout
import './styles/sidebar.css';      // Sidebar styling

import App from './App';
import BackendHealthCheck from './components/common/BackendHealthCheck';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BackendHealthCheck>
      <App />
    </BackendHealthCheck>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
